<script>
  import { router, page } from '@inertiajs/svelte'
  import Layout from '../../layouts/layout.svelte'
  import PageHeader from '../../components/page_header.svelte'
  import EntityList from '../../components/entity/entity_list.svelte'
  import Paginator from '../../components/paginator.svelte'
  import FilterBar from '../../components/filter_bar.svelte'
  import SearchInput from '../../components/search_input.svelte'
  import FilterSelect from '../../components/filter_select.svelte'
  import { Button } from '../../components/ui'
  import { confirm } from '../../components/confirm.js'

  let {
    adventures = [],
    pagy = { page: 1, pages: 1, count: 0 },
    total_count = null,
    filters = {},
    filter_options = {}
  } = $props()

  // `filters` arrives compacted by the server.
  const applyFilters = (changes) => {
    router.get('/adventures', { ...filters, ...changes }, { preserveState: true, preserveScroll: true })
  }

  const archive = async (item) => {
    const confirmed = await confirm({
      title: 'Confirm Archive',
      variant: 'error',
      body: 'Archiving is permanent unless reversed by a developer. Are you sure?'
    })
    if (!confirmed) return
    router.delete(`/adventures/${item.id}`, { preserveScroll: true })
  }
</script>

<Layout>
  <PageHeader title="Adventures" subtitle="Local deals and experiences at partner places" count={pagy.count} total={total_count}>
    {#snippet actions()}
      <Button href="/adventures/new" variant="primary" size="sm" icon="add">New Adventure</Button>
    {/snippet}
  </PageHeader>

  <FilterBar>
    {#snippet start()}
      <SearchInput value={filters.search || ''} param="search" placeholder="Search adventures…" />

      <FilterSelect
        label="Place"
        value={filters.place_id || ''}
        placeholder="All places"
        source="places"
        sourceParams={{ area_id: $page.props.current_area_id }}
        onchange={(v) => applyFilters({ place_id: v || undefined })}
      />

      <FilterSelect
        label="Type"
        value={filters.adventure_type || ''}
        placeholder="All types"
        options={filter_options.adventure_types ?? []}
        onchange={(v) => applyFilters({ adventure_type: v || undefined })}
      />
    {/snippet}
  </FilterBar>

  <EntityList entity="adventure" rows={adventures} onDelete={archive} />

  <Paginator {...pagy} />
</Layout>
